module.exports = __webpack_public_path__ + "img/Group 331.78c85a15.png";